import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADkirWfHdi_ojzt0BWNupuMW2HRaaIKVY",
  authDomain: "bozzetti-dashboard.firebaseapp.com",
  projectId: "bozzetti-dashboard",
  storageBucket: "bozzetti-dashboard.firebasestorage.app",
  messagingSenderId: "826919829402",
  appId: "1:826919829402:web:1b118e28f56db930908423",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);